<template>
	<div>
		<PageHeader
			:data="{
				name: 'Client Contacts',
				breadcrumbs: [{ name: 'Home', to: '/' }],
			}"
		/>

		<div v-if="!error" class="row mb-3">
			<!-- Filters -->
			<div class="col-12 mb-2">
				<div class="card">
					<div class="card-body">
						<div class="d-flex justify-content-between align-items-center">
							<div class="header d-flex align-items-center">
								<h4 class="p-0 m-0 me-2"><font-awesome-icon :icon="['fas', 'filter']" class="text-primary me-1" /> Filters</h4>
								<button v-if="Object.values(this.params).length > 4 && searchActive === ''" @click="clearFilters()" class="btn btn-sm btn-danger text-white me-2">
									Clear
									<font-awesome-icon :icon="['fas', 'times']" />
								</button>
								<button v-if="!searchSaving && haveParamsToSave() && searchActive === ''" @click="searchSaving = true" class="btn btn-sm btn-primary">
									Save search
								</button>
								<div v-if="searchSaving && searchActive === ''" class="save-search d-flex">
									<form @submit.prevent="storeSearch" class="d-flex">
										<input type="text" v-model="searchName" class="form-control form-control-sm ms-2" placeholder="enter search name" required />
										<button type="submit" class="btn btn-sm btn-primary ms-1">
											Save
										</button>
										<a role="button" @click="searchSaving = false" class="btn btn-sm ms-1">
											Cancel
										</a>
									</form>
								</div>
								<span v-if="searchActive !== ''" class="badge bg-success"
									>{{ searchActive }} <font-awesome-icon role="button" @click="clearFilters()" class="ms-2" :icon="['fas', 'times']"
								/></span>
							</div>
							<div class="action-buttons">
								<button
									data-bs-toggle="offcanvas"
									data-bs-target="#offcanvasSearches"
									aria-controls="offcanvasSearches"
									class="btn btn-outline-secondary btn-sm me-2"
								>
									Saved Searches <font-awesome-icon :icon="['fas', 'save']" class="me-1" />
								</button>
							</div>
						</div>

						<LPDataTableFilters :filters="table.filters" v-on:getFilters="getFilters($event.filters)" />
					</div>
				</div>
			</div>
			<!-- Table data -->
			<div class="col-12 mb-2">
				<div class="card">
					<div class="card-body">
						<div class="d-flex justify-content-between align-items-center">
							<div class="header d-flex align-items-center">
								<h4 class="p-0 m-0 me-2 text-capitalize">Clients Contacts</h4>
								<a
									v-if="authUser.permissions.includes('CLIENT_CONTACT_CREATE')"
									data-bs-toggle="modal"
									data-bs-target="#create"
									class="btn btn-outline-primary btn-sm"
									>Add Client Contact <font-awesome-icon :icon="['fas', 'plus-circle']" class="me-1"
								/></a>
							</div>

							<div class="action-buttons">
								<button
									data-bs-toggle="offcanvas"
									data-bs-target="#offcanvasTableSettings"
									aria-controls="offcanvasTableSettings"
									class="btn btn-outline-secondary btn-sm"
								>
									Table Settings <font-awesome-icon :icon="['fas', 'cogs']" class="me-1" />
								</button>
							</div>
						</div>
						<table :class="!loading && tableData.length > 0 ? 'table table-hover' : 'table table-hover loading'">
							<LPDataTableThead :thead="table.columns" :userColumns="userColumns" v-on:setOrder="setOrderBy($event.orderBy, $event.direction)" />
							<LPDataTableTbody
								:userColumns="userColumns"
								:authUser="authUser"
								:data="tableData"
								:tbody="table.columns"
								:model="model"
								:route="route"
								v-on:deleted="getTableData"
							/>
						</table>
						<div v-if="!loading && tableData.length === 0" class="col-md-12 text-center">
							<h4>No data available</h4>
						</div>
						<div v-if="loading && tableData.length === 0" class="d-flex justify-content-center">
							<div class="spinner-border" role="status">
								<span class="visually-hidden">Loading...</span>
							</div>
						</div>
						<div class="table-actions d-flex">
							<button data-bs-toggle="modal" data-bs-target="#exportModal" class="btn btn-success btn-sm me-2">
								Export <font-awesome-icon :icon="['fas', 'file-csv']" class="me-1" />
							</button>
							<router-link v-if="authUser.permissions.includes('CLIENT_CONTACT_IMPORT')" :to="`/${route}/import`" class="btn btn-primary btn-sm me-2">
								Import <font-awesome-icon :icon="['fas', 'file-csv']" class="me-1" />
							</router-link>
						</div>
						<LPDataTablePagination :pagination="pagination" v-on:getItems="getItems($event.page)" />
					</div>
				</div>
			</div>
		</div>

		<div v-else class="row mb-3">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<div class="alert alert-danger" role="alert">
							{{ error }}
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal for adding Data -->
		<div class="modal fade" id="create" tabindex="-1" aria-labelledby="createLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<form @submit.prevent="storeClient()">
						<div class="modal-header">
							<h5 class="modal-title" id="exampleModalLabel">New client contact</h5>
							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body">
							<h3>Create Client contact</h3>
							<div class="mb-2">
								<ContactSearch v-on:setContact="setContact" />
							</div>
							<div class="mb-2">
								<label for="">Client</label>
								<multiselect required :searchable="true" label="name" v-model="selectedClientId" :options="clients"></multiselect>
							</div>
							<div class="form-group mb-2">
								<label for="first_name">First Name</label>
								<input type="text" class="form-control" v-model="newContact.first_name" required />
							</div>
							<div class="form-group mb-2">
								<label for="last_name">Last Name</label>
								<input type="text" class="form-control" v-model="newContact.last_name" required />
							</div>
							<div class="form-group mb-2">
								<label for="email">Email</label>
								<input type="email" class="form-control" v-model="newContact.email" required />
							</div>
							<div class="form-group mb-2">
								<label for="phone">Phone</label>
								<input type="text" class="form-control" v-model="newContact.phone" />
							</div>
							<div class="form-group mb-2">
								<label for="address">Address</label>
								<input type="text" class="form-control" v-model="newContact.address" />
							</div>
							<div class="form-group mb-2">
								<label for="title">Title</label>
								<input type="text" class="form-control" v-model="newContact.title" required />
							</div>
							<div class="form-group mb-2">
								<label for="type">Type</label>
								<input type="text" class="form-control" v-model="newContact.type" required />
							</div>
							<div class="form-check form-switch mb-2 d-flex justify-content-start align-items-center">
								<input class="form-check-input" v-model="newContact.main" type="checkbox" id="main" checked />
								<label class="form-check-label ms-2" for="main">Main contact</label>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
							<button type="submit" class="btn btn-primary">Add</button>
						</div>
					</form>
				</div>
			</div>
		</div>

		<!-- Modal for adding Filter -->
		<div class="modal fade" id="addFilter" tabindex="-1" aria-labelledby="addFilterLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<form @submit.prevent="addFilter">
						<div class="modal-header">
							<h5 class="modal-title" id="exampleModalLabel">Add Filter</h5>
							<small class="ms-2">Adding new filter for {{ this.model }}</small>
							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body text-center">
							<h1>Will come soon 😉</h1>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
							<!-- <button type="submit" class="btn btn-primary">Save</button> -->
						</div>
					</form>
				</div>
			</div>
		</div>

		<!-- Modal for export -->
		<div class="modal fade" id="exportModal" tabindex="-1" aria-labelledby="exportModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel">Export {{ route }}</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div class="form-group mb-2">
							<label for="">Export Type</label>
							<select class="form-select" v-model="newExport.type">
								<option value="csv">CSV</option>
							</select>
						</div>
						<div class="form-group mb-2">
							<label for="">File Name</label>
							<div class="input-group mb-3">
								<input type="text" class="form-control" placeholder="File name" v-model="newExport.filename" />
								<span class="input-group-text" id="basic-addon2">.{{ newExport.type }}</span>
							</div>
						</div>
						<div class="form-group">
							<label for="">Columns to export</label>
							<div class="form-check">
								<input class="form-check-input" type="radio" v-model="newExport.columnsType" value="visible" id="visibleColumnsRadio" checked />
								<label class="form-check-label" for="visibleColumnsRadio">
									Export visible columns
								</label>
							</div>
							<div class="my-2" v-if="newExport.columnsType === 'visible'">
								<div class="d-flex flex-wrap">
									<div :key="'column-available-' + column" v-for="column in newExport.exportColumns" class="mb-2 me-1">
										<span class="badge bg-success">{{ column }}</span>
									</div>
								</div>
							</div>
							<div class="form-check">
								<input class="form-check-input" type="radio" v-model="newExport.columnsType" value="custom" id="customColumnsRadio" />
								<label class="form-check-label" for="customColumnsRadio">
									Export custom columns
								</label>
							</div>
							<div class="my-2" v-if="newExport.columnsType === 'custom'">
								<div class="d-flex flex-wrap">
									<small class="w-100 mb-1">ℹ️ Click on column to include/exclude it from export</small>
									<div :key="'column-available-' + column" v-for="column in newExport.availableColumns" class="mb-2 me-1">
										<span role="button" @click="toggleExportColumn(column)" v-if="newExport.exportColumns.includes(column)" class="badge bg-success">{{
											column
										}}</span>
										<span role="button" @click="toggleExportColumn(column)" v-else class="badge bg-secondary">{{ column }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
						<button v-if="!loadExporting && exportingFile === ''" @click="exportData()" type="submit" class="btn btn-primary">
							Create Export
						</button>
						<a v-if="!loadExporting && exportingFile !== ''" @click="downloadExport()" :href="exportingFile" class="btn btn-primary" download>
							Download
						</a>

						<button v-if="loadExporting" class="btn btn-primary" type="button" disabled>
							<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
							Loading...
						</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Offcanvas for Searches -->
		<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasSearches" aria-labelledby="offcanvasRightLabel">
			<div class="offcanvas-header">
				<h5 id="offcanvasRightLabel">Saved searches</h5>
				<button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
			</div>
			<div class="offcanvas-body">
				<h4 class="m-0">Your saved searches</h4>
				<p class="p-0"><small>ℹ️ Click on search to apply search filters to table</small></p>
				<div class="table-columns-settings">
					<div class="d-flex flex-wrap">
						<div :key="'user-searches-' + search.id" v-for="search in searches" class="mb-2 me-1">
							<span
								data-bs-toggle="offcanvas"
								data-bs-target="#offcanvasSearches"
								aria-controls="offcanvasSearches"
								role="button"
								@click="applySearch(search)"
								class="badge bg-success"
								>{{ search.name }}</span
							>
						</div>
					</div>
				</div>

				<small>👨‍🏫 Your saved searches for fast applying filters, you can add important ones to display above table (🚧 coming soon)</small>
			</div>
		</div>
		<!-- Offcanvas for Table Settings -->
		<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasTableSettings" aria-labelledby="offcanvasRightLabel">
			<div class="offcanvas-header">
				<h5 id="offcanvasRightLabel">Table settings</h5>
				<button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
			</div>
			<div class="offcanvas-body">
				<h4 class="m-0">Display columns</h4>
				<p class="p-0"><small>ℹ️ Select which columns to display in table</small></p>
				<div class="table-columns-settings">
					<div class="d-flex flex-wrap">
						<div :key="'column-available-' + column" v-for="column in availableColumns" class="mb-2 me-1">
							<span role="button" @click="toggleUserColumn(column)" v-if="userColumns.includes(column)" class="badge bg-success">{{ column }}</span>
							<span role="button" @click="toggleUserColumn(column)" v-else class="badge bg-secondary">{{ column }}</span>
						</div>
					</div>
				</div>

				<small>👨‍🏫 Selected columns are automatically saved to your browser storage and will be used again when you come on this page</small>

				<h4 class="mt-3">Display {{ this.route }} per page</h4>
				<p class="p-0">
					<small>ℹ️ Select how many {{ this.route }} to display per page in table</small>
				</p>
				<div class="form-group w-75">
					<select v-model="userPerPage" @change="setUserPerPage()" class="form-select">
						<option value="10">10 per page</option>
						<option value="15">15 per page</option>
						<option value="20">20 per page</option>
						<option value="30">30 per page</option>
						<option value="50">50 per page</option>
						<option value="100">100 per page</option>
					</select>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import { mapState } from 'vuex'
import restApi from '../../api/index.js'
import { Modal, Tooltip } from 'bootstrap'
import { handleErrors } from '../../actions/helpers'
import LPDataTablePagination from '@/components/lp-data-table/LPDataTablePagination'
import LPDataTableFilters from '@/components/lp-data-table/LPDataTableFilters'
import LPDataTableThead from '@/components/lp-data-table/LPDataTableThead'
import LPDataTableTbody from '@/components/lp-data-table/LPDataTableTbody'
import ContactSearch from '@/components/contact/ContactSearch'
export default {
	name: 'ClientContacts',
	components: {
		PageHeader,
		LPDataTablePagination,
		LPDataTableFilters,
		LPDataTableThead,
		LPDataTableTbody,
		ContactSearch,
	},
	data() {
		return {
			route: 'client-contacts',
			model: 'ClientContact',
			tableData: [],
			loading: false,
			error: '',
			newTableEntry: {},
			$createModal: null,
			$exportModal: null,
			$addFilterModal: null,
			pagination: {},
			page: this.$route.query.page || 1,
			orderBy: this.$route.query.orderBy || 'id',
			direction: this.$route.query.direction || 'asc',
			userPerPage: localStorage.getItem('client-contact-per-page') || 20,
			table: {
				columns: [
					{
						name: 'id',
						label: 'ID',
						sort: true,
						type: 'default',
					},
					{
						name: 'full_name',
						label: 'Municipality',
						sort: true,
						type: 'default',
					},
					{
						name: 'first_name',
						label: 'First Name',
						sort: false,
						type: 'default',
					},
					{
						name: 'last_name',
						label: 'Last Name',
						sort: false,
						type: 'default',
					},
					{
						name: 'email',
						label: 'Email',
						sort: false,
						type: 'default',
					},
					{
						name: 'name',
						label: 'Client',
						sort: false,
						type: 'default',
					},
					{
						name: 'email_secondary',
						label: 'Email second',
						sort: false,
						type: 'default',
					},
					{
						name: 'phone',
						label: 'Phone',
						sort: false,
						type: 'default',
					},
					{
						name: 'phone_secondary',
						label: 'Phone second',
						sort: false,
						type: 'default',
					},
					{
						name: 'address',
						label: 'Address',
						sort: true,
						type: 'default',
					},
					{
						name: 'address_mailing',
						label: 'Address mailing',
						sort: true,
						type: 'default',
					},
					{
						name: 'title',
						label: 'Title',
						sort: true,
						type: 'default',
					},
					{
						name: 'status',
						label: 'Status',
						sort: true,
						type: 'default',
					},
					{
						name: 'main',
						label: 'Main',
						sort: true,
						type: 'default',
					},
					{
						name: 'source',
						label: 'Source',
						sort: false,
						type: 'default',
					},
					{
						name: 'first_training_date',
						label: 'First training',
						sort: false,
						type: 'default',
					},
					{
						name: 'created_at',
						label: 'Created',
						sort: false,
						type: 'default',
					},
					{
						name: 'updated_at',
						label: 'Updated',
						sort: false,
						type: 'default',
					},
					{
						name: 'actions',
						label: 'Actions',
						sort: false,
						type: 'actions',
						width: 150,
						buttons: [
							{
								type: 'default',
								label: 'Edit',
								action: '',
								class: 'btn-primary',
								permission: `CLIENT_CONTACT_UPDATE`,
							},
							{
								type: 'delete',
								label: 'Delete',
								action: '',
								class: 'btn-danger',
								permission: `CLIENT_CONTACT_DELETE`,
							},
						],
					},
				],
				filters: [
					{
						display: true,
						name: 'search',
						label: 'Search',
						type: 'text',
						placeholder: 'enter text and press enter',
						colClass: 'col-4',
						value: this.$route.query.search || '',
					},
					{
						display: true,
						name: 'status',
						label: 'Status',
						type: 'select',
						placeholder: 'All statuses',
						colClass: 'col-2',
						value: this.$route.query.status || '',
						options: [
							{
								id: 'active',
								name: 'Active',
							},
							{
								id: 'deleted',
								name: 'Deleted',
							},
							{
								id: 'suspended',
								name: 'Suspended',
							},
						],
					},
					{
						display: true,
						name: 'tw_client',
						label: 'Town Web client',
						type: 'boolean',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.tw_client || '',
						options: [
							{
								id: 'no',
								name: 'No',
							},
							{
								id: 'yes',
								name: 'Yes',
							},
						],
					},
					{
						display: true,
						name: 'tk_client',
						label: 'Tweak client',
						type: 'boolean',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.tk_client || '',
						options: [
							{
								id: 'no',
								name: 'No',
							},
							{
								id: 'yes',
								name: 'Yes',
							},
						],
					},
					{
						display: true,
						name: 'hg_client',
						label: 'HeyGov Client',
						type: 'boolean',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.hg_client || '',
						options: [
							{
								id: 'no',
								name: 'No',
							},
							{
								id: 'yes',
								name: 'Yes',
							},
						],
					},
					{
						display: true,
						name: 'heygov_clerk_minutes',
						label: 'Clerk Minutes',
						type: 'boolean',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.heygov_clerk_minutes || '',
						options: [
							{
								id: 'no',
								name: 'No',
							},
							{
								id: 'yes',
								name: 'Yes',
							},
						],
					},
					{
						display: true,
						name: 'state',
						label: 'State',
						type: 'select',
						placeholder: 'All states',
						colClass: 'col-2',
						options: [],
						optionValue: true,
						optionsEndpoint: `municipalities/states`,
						value: this.$route.query.state || [],
					},
				],
			},
			params: {},
			userColumns: JSON.parse(localStorage.getItem(`client-contact-columns`)) || ['id', 'first_name', 'last_name', 'name', 'title', 'email', 'phone', 'actions'],
			availableColumns: ['id'],
			searchName: '',
			searchSaving: false,
			searchActive: '',
			searches: [],
			newExport: {
				type: 'csv',
				columnsType: 'visible',
				filename: '',
				availableColumns: ['id'],
				exportColumns: JSON.parse(localStorage.getItem(`client-contact-columns`)) || ['id', 'first_name', 'last_name', 'name', 'title', 'email', 'phone', 'actions'],
			},
			loadExporting: false,
			exportingFile: '',
			newContact: {
				client_id: null,
				municipality_id: null,
				contact_id: null,
				first_name: '',
				last_name: '',
				email: '',
				phone: '',
				email_secondary: '',
				phone_secondary: '',
				address: '',
				title: '',
				source: 'mc2',
				main: 0,
				first_training_date: null,
				type: '',
			},
			clients: [],
			selectedClientId: null,
		}
	},
	computed: {
		...mapState(['authUser', 'storageUrl']),
	},
	created() {
		this.table.filters.forEach(filter => {
			if (filter.value && filter.value !== '' && filter.value.length > 0) {
				this.params[filter.name] = filter.value
			} else {
				delete this.params[filter.name]
			}
			if (filter.from && filter.from !== '' && filter.to && filter.to !== '') {
				this.params['from' + filter.name] = filter.from
				this.params['to' + filter.name] = filter.to
			} else {
				delete this.params['from' + filter.name]
				delete this.params['to' + filter.name]
			}
		})
		setTimeout(() => {
			document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
				new Tooltip(el)
			})
		}, 1100)
		this.getTableColumns()
		this.getTableData(true)
		this.getSearches()
		this.getClients()
	},
	mounted() {
		this.$createModal = new Modal('#create')
		this.$addFilterModal = new Modal('#addFilter')
		this.$exportModal = new Modal('#exportModal')
	},
	methods: {
		// Get table Columns
		getTableColumns() {
			restApi
				.post('/helper/table-columns', { table: 'client_contacts' })
				.then(({ data }) => {
					this.newExport.availableColumns = data.map(column => column.name)
					this.availableColumns = data.map(column => column.name)
					this.availableColumns.push('address')
					this.availableColumns.push('name')
					this.availableColumns.push('address_mailing')
					this.availableColumns.push('actions')
					this.newExport.availableColumns.push('name')
					this.newExport.availableColumns.push('address')
					this.newExport.availableColumns.push('name')
					this.newExport.availableColumns.push('address_mailing')
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},
		// Get table data from API
		getTableData(first = false) {
			this.loading = true
			this.params = {
				...this.params,
				page: this.page,
				orderBy: this.orderBy,
				direction: this.direction,
				perPage: localStorage.getItem(`${this.model}-per-page`) || 20,
			}
			restApi
				.get(`/${this.route}`, { params: this.params })
				.then(({ data }) => {
					this.tableData = data.data
					this.pagination = data
					delete this.pagination.data
					this.loading = false
					if (!first) {
						this.$router.push({ path: this.$router.currentPath, query: this.params })
					}
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},
		// Adding new filter
		addFilter() {
			this.$addFilterModal.hide()
		},
		// Go to user page
		viewUser(user) {
			this.$router.push('/users/' + user.id)
		},
		// Get items from page that returned from LPDataTablePagination
		getItems(page) {
			this.page = page
			this.getTableData()
		},
		// Set direction
		setOrderBy(orderBy, direction) {
			this.orderBy = orderBy
			this.direction = direction
			this.getTableData()
		},
		// Get filters from LPDataTableFilters component
		getFilters(filters) {
			this.page = ''
			this.searchActive = ''
			filters.forEach(filter => {
				if (filter.value && filter.value !== '' && filter.value.length > 0) {
					this.params[filter.name] = filter.value
				} else {
					delete this.params[filter.name]
				}
				// Setting filter if its type is range
				if (filter.from && filter.from !== '' && filter.to && filter.to !== '') {
					this.params['from' + filter.name] = filter.from
					this.params['to' + filter.name] = filter.to
				} else {
					delete this.params['from' + filter.name]
					delete this.params['to' + filter.name]
				}
			})
			this.getTableData()
		},
		// Toggle user column
		toggleUserColumn(column) {
			if (this.userColumns.includes(column)) {
				this.userColumns = this.userColumns.filter(c => c !== column)
			} else {
				this.userColumns.push(column)
			}
			this.updateUserColumns()
		},
		// Update user columns
		updateUserColumns() {
			localStorage.setItem(`${this.model}-columns`, JSON.stringify(this.userColumns))
		},
		// Get user saved searches
		getSearches() {
			let params = {
				user_id: this.authUser.id,
				model: this.model,
			}
			restApi
				.get('/searches', { params })
				.then(({ data }) => {
					data.forEach(d => {
						d.data = JSON.parse(d.data)
						return d
					})
					this.searches = data
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},
		// Enable saving if some filters are set
		haveParamsToSave() {
			if (Object.values(this.params).length > 4) {
				return true
			} else {
				return false
			}
		},
		// Get user saved searches
		storeSearch() {
			let dataParams = this.params
			restApi
				.post('/searches', {
					user_id: this.authUser.id,
					model: `${this.model}`,
					name: this.searchName,
					data: JSON.stringify(dataParams),
				})
				.then(({ data }) => {
					data.data = JSON.parse(data.data)
					this.searches.push(data)
					this.searchActive = this.searchName
					this.searchSaving = false
					this.$swal.fire({
						icon: 'success',
						title: 'Search successfully saved!',
						timer: 4000,
					})
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},
		// Apply saved search to table
		applySearch(search) {
			// Reset all before applying saved search
			this.params = {}
			this.table.filters.forEach(filter => {
				if (filter.type !== 'range' && filter.type !== 'daterange') {
					filter.value = ''
				} else {
					filter.from = ''
					filter.to = ''
				}
			})
			// Apply saved search
			this.params = search.data
			let paramsArray = Object.keys(search.data)
			this.table.filters.forEach(filter => {
				if (paramsArray.includes(filter.name) && filter.type !== 'range') {
					filter.value = this.params[filter.name]
				}
				if (paramsArray.includes('from' + filter.name) && filter.type === 'range') {
					filter.from = this.params['from' + filter.name]
					filter.to = this.params['to' + filter.name]
				}
				if (paramsArray.includes('from' + filter.name) && filter.type === 'daterange') {
					filter.from = this.params['from' + filter.name]
					filter.to = this.params['to' + filter.name]
				}
			})
			this.searchActive = search.name
			this.getTableData()
		},
		// Clear all filters
		clearFilters() {
			this.params = {}
			this.searchActive = ''
			this.table.filters.forEach(filter => {
				if (filter.type !== 'range' && filter.type !== 'multiselect') {
					filter.value = ''
				}
				if (filter.type === 'multiselect') {
					filter.value = []
				}
				if (filter.type === 'range' || filter.type === 'daterange') {
					filter.from = ''
					filter.to = ''
				}
			})
			this.getTableData()
		},
		// Toggle export column
		toggleExportColumn(column) {
			if (this.newExport.exportColumns.includes(column)) {
				this.newExport.exportColumns = this.newExport.exportColumns.filter(c => c !== column)
			} else {
				this.newExport.exportColumns.push(column)
			}
		},
		// Export table Data
		exportData() {
			this.loadExporting = true
			this.newExport.exportColumns = this.newExport.exportColumns.filter(column => column !== 'actions')
			restApi
				.post(`/${this.route}/export`, {
					params: JSON.stringify(this.params),
					columns: JSON.stringify(this.newExport.exportColumns),
					filename: this.newExport.filename,
				})
				.then(({ data }) => {
					this.loadExporting = false
					this.exportingFile = this.storageUrl + '/tmp/' + data.file
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},
		// Download exported Data
		downloadExport() {
			this.$exportModal.hide()
			this.newExport.filename = ''
			this.exportingFile = ''
		},
		// Set user per page
		setUserPerPage() {
			localStorage.setItem(`${this.model}-per-page`, this.userPerPage)
			this.getTableData()
		},

		setContact(contact) {
			if (contact !== null) {
				this.newContact.contact_id = contact.id
				this.newContact.first_name = contact.first_name
				this.newContact.last_name = contact.last_name
				this.newContact.email = contact.email
				this.newContact.phone = contact.phone
				this.newContact.email_secondary = contact.email_secondary
				this.newContact.address = contact.address
				this.newContact.title = contact.title
				this.newContact.main = contact.main
				this.newContact.type = contact.type
			} else {
				this.newContact.contact_id = null
				this.newContact.first_name = ''
				this.newContact.last_name = ''
				this.newContact.email = ''
				this.newContact.phone = ''
				this.newContact.email_secondary = ''
				this.newContact.address = ''
				this.newContact.title = ''
				this.newContact.main = ''
				this.newContact.type = ''
			}
		},

		getClients() {
			restApi
				.get(`/clients/active-clients`)
				.then(({ data }) => {
					this.clients = data
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		storeClient() {
			// If client is not municipal
			if (this.newContact.municipality_id === null) {
				// Store client contact to client contacts table its non municipal client
				restApi
					.post(`/client-contacts`, this.newContact)
					.then(({ data }) => {
						this.newContact.contact_id = data.id
						this.$createModal.hide()
						this.$router.push(`/client-contacts/edit/${data.id}`)
						this.cancelAddingClient()
					})
					.catch(error => {
						this.$swal.fire({
							icon: 'error',
							title: handleErrors(error, ''),
							timer: 6000,
						})
					})
			} else {
				if (this.newContact.contact_id === null) {
					// Create new contact in Contacts table and in Client contacts
					restApi
						.post(`/contacts`, this.newContact)
						.then(({ data }) => {
							this.$createModal.hide()
							this.newContact.contact_id = data.id
							restApi
								.post(`/client-contacts`, this.newContact)
								.then(({ data }) => {
									this.$router.push(`/client-contacts/edit/${data.id}`)
									this.cancelAddingClient()
								})
								.catch(error => {
									this.$swal.fire({
										icon: 'error',
										title: handleErrors(error, ''),
										timer: 6000,
									})
								})
						})
						.catch(error => {
							this.$swal.fire({
								icon: 'error',
								title: handleErrors(error, ''),
								timer: 6000,
							})
						})
				} else {
					// Update contact in Contacts table and create new contact in client table
					restApi
						.post(`/client-contacts`, this.newContact)
						.then(({ data }) => {
							let clientContactId = data.id
							this.$createModal.hide()
							restApi
								.put(`/contacts/${this.newContact.contact_id}`, this.newContact)
								.then(() => {
									this.$router.push(`/client-contacts/edit/${clientContactId}`)
									this.cancelAddingClient()
								})
								.catch(error => {
									this.$swal.fire({
										icon: 'error',
										title: handleErrors(error, ''),
										timer: 6000,
									})
								})
						})
						.catch(error => {
							this.$swal.fire({
								icon: 'error',
								title: handleErrors(error, ''),
								timer: 6000,
							})
						})
				}
			}
		},

		cancelAddingClient() {
			this.newContact.municipality_id = null
			this.newContact.contact_id = null
			this.newContact.first_name = ''
			this.newContact.last_name = ''
			this.newContact.email = ''
			this.newContact.phone = ''
			this.newContact.email_secondary = ''
			this.newContact.address = ''
			this.newContact.title = ''
			this.newContact.main = ''
			this.newContact.type = ''
		},
	},

	watch: {
		selectedClientId: function() {
			this.newContact.client_id = this.selectedClientId.id
			this.newContact.municipality_id = this.selectedClientId.municipality_id
		},
	},
}
</script>
